import { useCallback } from 'react';
import { useAppDispatch } from '../useReduxToolkit';
import { openModal } from '../../features/modals/modals.slice';
import { ModalId } from '../../features/modals/modals.type';

export const useOnUpgradeSubscription = (): (() => void) => {
  const dispatch = useAppDispatch();

  return useCallback((): void => {
    dispatch(openModal(ModalId.UpgradeSubscription));
  }, []);
};
